import { render, staticRenderFns } from "./ModifiersEditor.vue?vue&type=template&id=72952f9e"
import script from "./ModifiersEditor.vue?vue&type=script&lang=js"
export * from "./ModifiersEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports